import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/yimo-img/interface-2.png'
import _imports_1 from '../../assets/img/yimo-img/word-1.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-3797963c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-one" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "next" }, null, -1))
const _hoisted_3 = { class: "yimo-main" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "interface",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "word",
  src: _imports_1,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_download_btn = _resolveComponent("download-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["box2 animate__faster", {
          animate__animated: _ctx.nowPage === 0,
          animate__fadeInRight: _ctx.nowPage === 0
        }])
      }, _hoisted_5, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["box1 animate__faster", { animate__animated: _ctx.nowPage === 0, animate__fadeInLeft: _ctx.nowPage === 0 }])
      }, [
        _hoisted_6,
        _createElementVNode("div", {
          class: _normalizeClass(["pageTowWord", {
            animate__animated: _ctx.nowPage === 0,
            animate__fadeInLeft: _ctx.nowPage === 0
          }])
        }, null, 2)
      ], 2),
      _createVNode(_component_download_btn, {
        class: _normalizeClass({ animate__animated: _ctx.nowPage === 0, animate__fadeInUp: _ctx.nowPage === 0 })
      }, null, 8, ["class"])
    ])
  ]))
}